import BaseComponent from "./base_component_controller";
import { useChartConfig } from "hb/insights/use_chart_config";

export default class extends BaseComponent {
  static viewId = "billboard";

  static targets = ["billboardTemplate"];

  static get values() {
    return {
      ...BaseComponent.values,

      querySessionId: String,
      schema: Array,
      results: Array,
      chartConfig: Object,
    };
  }

  static configs = [
    { name: "groupType", default: "events" },
    "titleField",
    "titleURLField",
    "subtitleField",
    "valueField",
    "statusField",
  ];

  connect() {
    useChartConfig(this);
    this.billboardTemplate = this.compileElement(this.billboardTemplateTarget);

    super.connect();
  }

  outletsConnected() {
    super.outletsConnected();
    this.initQuery();
  }

  queryContextDefaults() {
    const { meta, results } = this.query;
    let config = {};

    // From Fields
    //
    if (results.length === 1) {
      config.groupType = "fields";

      // From Events
      //
    } else if (results.length <= 10) {
      config.groupType = "events";

      const [f1, f2] = meta.fields;
      if (f1 && f2) {
        config.titleField = f1;
        config.valueField = f2;
      } else if (f1) {
        config.titleField = "";
        config.valueField = f1;
      }
    }

    return config;
  }

  validate() {
    let { groupField, statusField, valueField } = this.config;
    let { results } = this.query;

    if (this.hasUnknownFields(groupField, statusField, valueField)) {
      this.errorMessage = "Unknown field selected";
    } else if (results?.length > 10) {
      this.errorMessage = "There are too many results";
    }
  }

  renderConfig() {
    const { meta } = this.query;

    [
      "subtitleField",
      "titleField",
      "titleURLField",
      "valueField",
      "statusField",
    ].forEach((name) => {
      let allFields;
      if (
        [
          "titleField",
          "statusField",
          "subtitleField",
          "titleURLField",
        ].includes(name)
      ) {
        allFields = ["__empty", ...meta.fields];
      } else {
        allFields = meta.fields;
      }

      this.find(`[data-input-name="${name}"] ul`).innerHTML = allFields
        .map((field) =>
          this.comboboxItemTemplate({
            classes: this[name] === field ? "current" : "",
            value: field,
            id: field,
            display: field,
            ...(field == "__empty" && {
              display: null,
              badge: "none",
            }),
          }),
        )
        .join("\n");
    });

    this.find(
      `input[name="groupType"][id="${this.config.groupType}"]`,
    ).checked = "true";
    this.find(`input[name="titleField"]`).value = this.config.titleField || "";
    this.find(`input[name="titleURLField"]`).value =
      this.config.titleURLField || "";
    this.find(`input[name="subtitleField"]`).value =
      this.config.subtitleField || "";
    this.find(`input[name="valueField"]`).value = this.config.valueField || "";
    this.find(`input[name="statusField"]`).value =
      this.config.statusField || "";
  }

  render() {
    const { results } = this.query;
    let final;

    if (this.config.groupType === "fields") {
      // Single row, multiple fields
      //
      const [result] = results;
      final = Object.entries(result.selectedFields).map(([title, value]) =>
        this.billboardTemplate({ title, value }),
      );
    } else if (this.config.groupType === "events") {
      // Multiple rows
      //
      final = results.map((result) => {
        if (this.config.titleField) {
          return this.billboardTemplate({
            title: result.field(this.config.titleField),
            titleURL: result.field(this.config.titleURLField),
            subtitle: result.field(this.config.subtitleField),
            value: result.field(this.config.valueField),
            status: result.field(this.config.statusField),
          });
        } else {
          return this.billboardTemplate({
            value: result.field(this.config.valueField),
          });
        }
      });
    }

    this.outletComponent("chart")?.setChartHtml(final.join("\n"));
  }
}
